module.exports = __webpack_public_path__ + "static/vslide_4@2x-d7d2e8645d0ee95c351c759db04583fd.png";